export const isFile = (x: any): x is InstanceType<typeof File> => {
  if (!x) return false;
  if (typeof x !== 'object') return false;
  return (typeof x.arrayBuffer === 'function') && typeof x.size !== 'undefined';
}
